module.exports = __webpack_public_path__ + "static/img/bootstrap.7384412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/bootstrap.png
// module id = 512
// module chunks = 1